export default {
  menu: {
    sports: "กีฬา",
    referAndEarn: "แนะนำและรับรางวัล",
    referDesc: "คอมมิชชั่นสูงสุด 60%",
    copyLink: "คัดลอกลิงก์",
    hot: "ยอดนิยม",
    favorites: "รายการโปรด",
    recent: "ล่าสุด",
    vipClub: "VIP คลับ",
    bonus: "โบนัส",
    bonusGames: "เกมโบนัส",
    affiliate: "พันธมิตร",
    promotion: "โปรโมชั่น",
    rewards: "รางวัล",
    help: "ช่วยเหลือ",
    feedback: "ข้อเสนอแนะ",
    downloadApp: "ดาวน์โหลดแอป",
    claimBonus: "รับโบนัส",
    redeemCode: 'แลกรหัส',
    redeemDesc: 'รับรางวัลฟรีของคุณ',
    liveSupport: "ฝ่ายสนับสนุนสด",
    language: "ภาษา",
	search: "search"
  }
}
